import { DEFAULT_ERROR_MESSAGE } from 'data/message';
import { EventQuery } from 'queries';
import { toast } from 'react-toastify';
import { IEvent } from 'types';

interface Props {
  event?: IEvent | null;
}

export function useEventStatus({ event }: Props) {
  const { mutate } = EventQuery.useUpdateStatus();
  const handleEventStatus = (eventStatus: IEvent['eventStatus']) => {
    if (!event) return;
    if (!event?.id) return;
    if (!event.additionalId) {
      toast.error('추가정보를 등록해주세요');
      return;
    }

    if (!event.feedbackId) {
      toast.error('피드백을 등록해주세요');
      return;
    }

    if (!event.description) {
      toast.error('상세정보를 입력해주세요');
      return;
    }

    mutate(
      { id: event.id, eventStatus },
      {
        onSuccess: () => {
          toast.success(getEventStatusText(eventStatus));
        },
        onError: (error: any) => {
          const message =
            error?.response?.data?.message ?? DEFAULT_ERROR_MESSAGE;
          toast.error(message);
        },
      },
    );
  };

  return { handleEventStatus };
}

const getEventStatusText = (eventStatus: IEvent['eventStatus']) => {
  switch (eventStatus) {
    case 'RECRUITING':
      return '행사가 승인되었습니다.';
    case 'RECRUITMENT_CLOSED':
      return '모집 완료되었습니다.';
    case 'COMPLETED':
      return '진행 완료되었습니다.';
    case 'CANCELLED':
      return '행사가 취소되었습니다.';
    default:
      return '행사 상태가 변경되었습니다.';
  }
};
